<template>
  <div class="works-component guiHome ">
    <div class="banner"> 
      <img src="../../../assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 black text-left m-0">
          归 | Home
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-1px">
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/01-landscape-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(0)" >
           
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/01-landscape-liv-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(1)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/01-landscape-liv-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(2)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/02-portrait-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(3)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/02-portrait-liv-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(4)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/03-full-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(5)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/04-portrait-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(6)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/04-portrait-liv-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(7)" >
        </b-col> 
      </b-row> 
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/05-landscape-dry-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(8)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/05-landscape-dry-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(9)" >
        </b-col> 
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/05-landscape-dry-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(10)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col >
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/06-full-master-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(11)" >
        </b-col> 
      </b-row>  
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/07-landscape-master-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(12)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/07-landscape-master-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(13)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/07-landscape-master-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(14)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/08-portrait-master-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(15)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/08-portrait-master-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(16)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/09-landscape-guest-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(17)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/09-landscape-guest-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(18)" >
        </b-col> 
      </b-row> 
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/10-landscape-master-1 1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(19)" >
        </b-col>
      </b-row>   
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="White-Wood"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 black  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">白 + 木 | WhiteWood</p>
              <p class="inter inter-body-md-400 black p-0">USJ 5 | Subang Jaya</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 black  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">漫乐 | Romance in the house</p>
              <p class="inter inter-body-md-400 black p-0">Eco Spring | Johor</p>
            </b-col>
            <b-col cols="3" to="Romance-In-The-House"  tag="router-link" ><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right.svg"></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
    <GlobalLightbox
      :visible.sync="lightboxVisible"
      :images="resolvedImages"
      :index="currentIndex"
    />
  </div>

</template>

<script>
import GlobalLightbox from "@/components/GlobalLightbox.vue";
export default {
  name: 'guiHome',
    components: { GlobalLightbox },
data() {
    return { 
      basePath: "@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING",
      images: [ 
        "01-landscape-liv-1.jpg",
        "01-landscape-liv-2.jpg",
        "01-landscape-liv-3.jpg",
        "02-portrait-liv-1.jpg",
        "02-portrait-liv-2.jpg",
        "03-full-liv-1.jpg",
        "04-portrait-liv-1.jpg",
        "04-portrait-liv-2.jpg",
        "05-landscape-dry-1.jpg",
        "05-landscape-dry-2.jpg",
        "05-landscape-dry-3.jpg",
        "06-full-master-1.jpg",
        "07-landscape-master-1.jpg",
        "07-landscape-master-2.jpg",
        "07-landscape-master-3.jpg",
        "08-portrait-master-1.jpg",
        "08-portrait-master-2.jpg",
        "09-landscape-guest-2.jpg",
        "09-landscape-guest-3.jpg",
        "10-landscape-master-1 1.jpg", 
       ],
      lightboxVisible: false,
      currentIndex: 0
    }
  },
  computed: {
    resolvedImages() {
     return this.images.map(img => 
      require(`@/assets/img/works/semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/${img}`)
    );
  }
  },
  methods: { 
    showLightbox(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    }
  }, 

}
</script>

<style>
 
.guiHome{
  background-color: #EFEFE7 ;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.guiHome p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>